import {
  _PROCESS_ERROR, _COMMIT_LOG, PUBLIC_PROCESS_GOOGLE_PLACE,
  PUBLIC_GET_PLANS, PUBLIC_REGISTER_USER,
  PUBLIC_SEND_VERIFY_EMAIL, PUBLIC_VERIFY_EMAIL_CODE,
  PUBLIC_SEND_VERIFY_SMS, PUBLIC_VERIFY_SMS_CODE,
  PUBLIC_IS_EMAIL_UNIQUE, SIGNUP_GET_PLANS_AVAIL,
  PUBLIC_REQUEST_PASSWORD_RESET, PUBLIC_COMMIT_PASSWORD_RESET,
} from './actions.types'
import {
  PUBLIC_SET_PLANS,
  PUBLIC_RESET_PLANS,
} from './mutations.types'
import PublicService from '../services/public.service'

const initialState = {
  plans: [],
}

export const state = { ...initialState }

export const actions = {
  async [PUBLIC_GET_PLANS] ({ dispatch, commit, rootState }) {
    try {
      const response = await PublicService.getPlans()
      console.log('GET plans response: ', response.data)
      commit(PUBLIC_SET_PLANS, response.data)
      return response.data
    } catch (e) {
      throw await dispatch(_PROCESS_ERROR, e)
    }
  },
  async [PUBLIC_PROCESS_GOOGLE_PLACE] ({ dispatch, commit, rootState }, payload) {
    try {
      console.log('Processing place change:', payload)
      // eslint-disable-next-line camelcase
      const { geometry, place_id } = payload
      // console.log(address_components)
      const lat = await geometry.location.lat()
      const lng = await geometry.location.lng()
      const latlng = { lat, lng, place_id }
      await dispatch(SIGNUP_GET_PLANS_AVAIL, latlng)
      console.log(latlng)
      return latlng
    } catch (e) {
      throw await dispatch(_PROCESS_ERROR, e)
    }
  },
  /***
   * Register a user account with a unique email address
   * @param {string} payload.email_address email address of the user we are creating
   * @param {string} payload.mobile_number mobile phone number for SMS/calls
   * @param {string} payload.phone_number phone number to call the user
   * @param {string} payload.password
   * @param {string} payload.first_name
   * @param {string} payload.last_name
   * @param {boolean} payload.opt_in_sms
   * @param {boolean} payload.opt_in_email
   * @returns {*}
   */
  async [PUBLIC_REGISTER_USER] ({ dispatch, commit, rootState }, payload) {
    try {
      console.log('Registering new user:', payload)
      const { data } = await PublicService.registerUser(payload)
      console.log(data)
      return data
    } catch (e) {
      throw await dispatch(_PROCESS_ERROR, e)
    }
  },
  /***
   * Check if the provided email is unique
   * @param {string} payload.email_address email address of the user we are creating
   * @returns {*}
   */
  async [PUBLIC_IS_EMAIL_UNIQUE] ({ dispatch, commit, rootState }, payload) {
    try {
      console.log('Checking if email_address is unique:', payload)
      const { data } = await PublicService.getEmailUnique(payload)
      console.log(data)
      return true
    } catch (e) {
      return false
      // throw await dispatch(_PROCESS_ERROR, e)
    }
  },
  /***
   * Send email to user to verify they have access to the mailbox
   * @param {string} payload.contact email address we are wanting to verify
   * @returns {*}
   */
  async [PUBLIC_SEND_VERIFY_EMAIL] ({ dispatch, commit, rootState }, payload) {
    try {
      console.log('Attempting to send an email verification code to:', payload)
      const { data } = await PublicService.postAction('send-verify-email', payload)
      console.log(data)
      return data
    } catch (e) {
      return false
      // throw await dispatch(_PROCESS_ERROR, e)
    }
  },
  /***
   * Attempt to verify the code and email_address pair are valid
   * @param {string} payload.contact email address we are wanting to verify
   * @param {string} payload.code code to test
   * @returns {*}
   */
  async [PUBLIC_VERIFY_EMAIL_CODE] ({ dispatch, commit, rootState }, payload) {
    try {
      console.log('Attempting to verify code is valid:', payload)
      const { data } = await PublicService.postAction('verify-email', payload)
      console.log(data)
      return data
    } catch (e) {
      return false
      // throw await dispatch(_PROCESS_ERROR, e)
    }
  },
  /***
   * Send sms to user to verify they have access to the mailbox
   * @param {string} payload.contact email address we are wanting to verify
   * @returns {*}
   */
  async [PUBLIC_SEND_VERIFY_SMS] ({ dispatch, commit, rootState }, payload) {
    try {
      console.log('Attempting to send a SMS verification code to:', payload)
      const { data } = await PublicService.postAction('send-verify-sms', payload)
      console.log(data)
      return data
    } catch (e) {
      return false
      // throw await dispatch(_PROCESS_ERROR, e)
    }
  },
  /***
   * Attempt to verify the code and mobile number pair are valid
   * @param {string} payload.contact mobile number we are wanting to verify
   * @param {string} payload.code code to test
   * @returns {*}
   */
  async [PUBLIC_VERIFY_SMS_CODE] ({ dispatch, commit, rootState }, payload) {
    try {
      console.log('Attempting to verify code is valid:', payload)
      const { data } = await PublicService.postAction('verify-sms', payload)
      console.log(data)
      return data
    } catch (e) {
      return false
      // throw await dispatch(_PROCESS_ERROR, e)
    }
  },
  /***
   * Request a password reset email be sent
   * @param {string} payload.email_address email address of the user we are resetting
   * @returns {*}
   */
  async [PUBLIC_REQUEST_PASSWORD_RESET] ({ dispatch, commit, rootState }, payload) {
    try {
      await dispatch(_COMMIT_LOG, { message: 'Requesting password reset', payload })
      const { data } = await PublicService.requestPasswordReset(payload)
      await dispatch(_COMMIT_LOG, { message: 'password reset response', data })
      return data
    } catch (e) {
      throw await dispatch(_PROCESS_ERROR, e)
    }
  },
  /***
   * Commit a password reset with token
   * @param {string} payload.email_address email address of the user we are resetting
   * @param {string} payload.token token string to authenticate request
   * @param {string} payload.password new password to reset account to
   * @returns {*}
   */
  async [PUBLIC_COMMIT_PASSWORD_RESET] ({ dispatch, commit, rootState }, payload) {
    try {
      await dispatch(_COMMIT_LOG, 'Comitting password reset')
      const { data } = await PublicService.commitPasswordReset(payload)
      await dispatch(_COMMIT_LOG, data)
      return data
    } catch (e) {
      throw await dispatch(_PROCESS_ERROR, e)
    }
  },
}

export const mutations = {
  [PUBLIC_SET_PLANS] (state, data) {
    state.plans = data
  },
  [PUBLIC_RESET_PLANS] (state, data) {
    state.plans = initialState.plans
  },

}
export const getters = {
  publicPlans: state => state.plans,
}

export default {
  state,
  actions,
  mutations,
  getters,
}
